import React from "react";

const CreateFormOptions = ({
  index,
  type,
  options,
  updateOption,
  addOption,
}) => {
  return (
    <div className="mt-2 ml-2">
      {options.map((option, optionIndex) => (
        <input
          key={optionIndex}
          value={option}
          type="text"
          className="form-control form-control-sm m-2"
          placeholder={`Option ${optionIndex + 1}`}
          onChange={(event) =>
            updateOption(index, type, optionIndex, event.target.value)
          }
        ></input>
      ))}
      <div
        className="btn btn-secondary m-2"
        onClick={() => addOption(index, type)}
      >
        Add Option
      </div>
    </div>
  );
};

export default CreateFormOptions;
